module.exports = __webpack_public_path__ + "static/img/about.7d4f289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/health/about.png
// module id = qllG
// module chunks = 1